import { Fragment } from 'react';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Router from './router/Router';
import './styles/layout.scss';
import './styles/media.scss';
import './styles/reset.css';
import './styles/font.scss';
import TopButton from './components/TopButton/TopButton';

function App() {
  return (
    <Fragment>
      <div className="wrap">
        <Header />
        <Router />
        <Footer />
        <TopButton />
      </div>
    </Fragment>
  );
}

export default App;
